/**
 * Copyright 2026 Perform Content Services Limited. Confidential and Proprietary. All Rights Reserved.
 */

import GlobalScope from '../globalScope/GlobalScope';
import FeatureEnablement from '../environment/FeatureEnablement';

export default class GarbageCollectorManager {
  static forceGarbageCollection(): void {
    if (FeatureEnablement.isForceChromeGarbageCollectionSupported) {
      this.forceChromeGarbageCollection();
    }
  }

  private static forceChromeGarbageCollection(): void {
    if (FeatureEnablement.isQueueMicrotaskSupported) {
      GlobalScope.value.queueMicrotask(this.overloadMemoryToInvokeGarbageCollection.bind(this));
    } else {
      GlobalScope.value.setTimeout(this.overloadMemoryToInvokeGarbageCollection.bind(this), 0);
    }
  }

  private static overloadMemoryToInvokeGarbageCollection(): void {
    let img: HTMLImageElement | null = GlobalScope.value.documentCreateElement<HTMLImageElement>('img');

    img.src = GlobalScope.value.URL.createObjectURL(new Blob([new ArrayBuffer(10e+7)])); // 100Mb or less or more depending on as you wish to force/invoke GC cycle run
    img.onerror = function() {
      GlobalScope.value.URL.revokeObjectURL(this.src);

      img = null;
    };
  }

  private constructor() {
    throw new Error('GarbageCollectorManager is a static class that may not be instantiated');
  }
}